import React from 'react';

import { BackportingEnums } from '../../../../../../generated/compat/backportingEnums';
import { GeneralRatiosInfo } from '../../../../../../generated/model/models';
import MatrixDataTable from '../../shared/MatrixDataTable';

export interface Props {
  data?: GeneralRatiosInfo[];
  ccy?: BackportingEnums.CcyEnum;
}

const TABLE_FIELDS = [
  'intangibleFixedAssetsTotalAssets',
  'intangibleFixedAssetsTurnover',
  'tangibleFixedAssetsTotalAssets',
  'tangibleFixedAssetsTurnover',
  'debtorsTurnover',
  'stockTotalAssets',
  'stockTurnover',
  'currentLiabilitiesCostOfGoodsSold',
  'currentLiabilitiesDebtors',
];

const GeneralRatios: React.FC<Props> = ({ data, ccy }) => {
  return (
    <MatrixDataTable
      title={'generalRatios'}
      translationsScope={'companies:companyRatios'}
      data={data}
      tableFields={TABLE_FIELDS}
      ccy={ccy}
    />
  );
};

export default GeneralRatios;
